
export const GET_OVERTIME_REQUESTS = 'GET_OVERTIME_REQUESTS';
export const ADD_OVERTIME_REQUEST = 'ADD_OVERTIME_REQUEST';
export const APPROVE_OVERTIME_REQUEST = 'APPROVE_OVERTIME_REQUEST';
export const REJECT_OVERTIME_REQUEST = 'REJECT_OVERTIME_REQUEST';
export const GET_MY_OVERTIME_REQUESTS = 'GET_MY_OVERTIME_REQUESTS';
export const SET_COEFFICIENT = 'SET_COEFFICIENT'